import React from 'react';
import './Adds.css';

const script = document.createElement("script");
script.src =  "https://a.st1net.com/ad-provider.js";
script.async = true;
script.type = "application/javascript";
script.id = "shaft-ad-script";

class Adds extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      replaceAd: true,
      adProviderIsSet: false
    };
  }

  setAdProvider = () => {
    if (window.AdProvider && !this.state.adProviderIsSet) {
      window.AdProvider.push({"serve": {}});
      this.setState({adProviderIsSet: true});
    }
    else if (window.AdProvider && this.state.adProviderIsSet) {
      return;
    }
    else {
    window.AdProvider = [];
    }
  }

  selectAd = () => {
    const num =  Math.floor(Math.random() * 2);
    if (num === 0) {
      this.setState({replaceAd : false})
    }
    else {
    this.setState({replaceAd : true})
    }
  }

  componentDidMount() { 
    let adScriptIsAdded = document.getElementById("shaft-ad-script");
    this.setState({adProviderIsSet: false});
    if (!adScriptIsAdded) {
      document.head.appendChild(script);
    }
    this.setAdProvider();
    this.selectAd();
  };

  componentDidUpdate() {
    this.setAdProvider();
  }

  render() {
    const { replaceAd } = this.state;
    const { isAnchorPageAd } = this.props;
    const adClass = isAnchorPageAd ? "anchor-page-ads" : "adds";
    const selectedAdClass = replaceAd ? "hide-native-ad" : "hide-ext-ad";

    return (
    <div className={adClass}>
      <div className={selectedAdClass}>

        <div className={`native-ad desktop`}>
          <ins className='adsbyshafttraffic' data-zoneid='2464'></ins>
        </div>

        <div className="native-ad mobile">
          <ins className="adsbyshafttraffic" data-zoneid='2454'></ins>
        </div>

        {!isAnchorPageAd &&
        <div className={'ext-ads desktop'}>
          <ins className='adsbyshafttraffic' data-zoneid='2424'></ins>
        </div>
        }

        {isAnchorPageAd &&
        <div className={'ext-ads desktop'}>
          <ins className='adsbyshafttraffic' data-zoneid='2436'></ins>
          <ins className='adsbyshafttraffic' data-zoneid='2448'></ins>
          <ins className='adsbyshafttraffic' data-zoneid='2450'></ins>
        </div>
        }

        <div className='ext-ads mobile'>
          <ins className='adsbyshafttraffic' data-zoneid="2442"></ins>
        </div>

      </div>
    </div>
  )
}
};

export default Adds;
